import { chevron_right_gray400, pencil_gray400, trash_can_error } from '@assets/icons';
import {
  CollectionUpsertModal,
  Frame,
  GuideModal,
  ImageListItemComponent,
  ImageModal,
  MenuTop,
  Text
} from '@components';
import { PathnameEnum } from '@constant';
import { useCollectionImageList } from '@hooks';
import { Button } from '@mui/material';
import { colorSet } from '@theme';
import { IImageListItem } from '@types';

const CollectionImageListPage = () => {
  const {
    handleBreadCrumbClick,
    collectionId,
    initialCollectionName,
    data,
    flattenCollectionImageList,
    outputBottomRef,
    isImageModalVisible,
    imageModalType,
    selectedImageInfo,
    sequenceInfo,
    handleImageClick,
    handleImageModalClose,
    handleImageUseButtonClick,
    isCollectionUpsertModalVisible,
    handleCollectionUpsertModalOpen,
    handleCollectionUpsertModalClose,
    isCollectionDeleteModalVisible,
    handleCollectionDeleteModalOpen,
    handleCollectionDeleteModalClose,
    handleCollectionDeleteConfirmClick
  } = useCollectionImageList();

  const horizontalGap = 15;
  const itemNumberPerRow = 7;
  const sumOfHorizontalGaps = horizontalGap * (itemNumberPerRow - 1);
  const itemSize = `calc((100% - ${sumOfHorizontalGaps}px) / ${itemNumberPerRow})`;

  return (
    <>
      <MenuTop />

      <Frame width="100%" padding="48px 40px 96px 40px">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginBottom: '80px'
          }}
        >
          <div>
            <div
              onClick={handleBreadCrumbClick}
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: '4px',
                cursor: 'pointer'
              }}
            >
              <Text variant="body1" color="primary" marginRight="10px">
                컬렉션
              </Text>
              <img src={chevron_right_gray400} style={{ width: 16, height: 16 }} />
            </div>
            <Text variant="h2" fontWeight="bold">
              {initialCollectionName}
            </Text>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                handleCollectionUpsertModalOpen();
              }}
              sx={{ width: 84, height: 44 }}
            >
              <img src={pencil_gray400} alt="" style={{ width: 20, height: 20 }} />
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={() => {
                handleCollectionDeleteModalOpen();
              }}
              sx={{ width: 84, height: 44 }}
            >
              <img src={trash_can_error} alt="" style={{ width: 20, height: 20 }} />
            </Button>
          </div>
        </div>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: `15px ${horizontalGap}px`,
            width: '100%',
            boxSizing: 'border-box'
          }}
        >
          {data &&
            flattenCollectionImageList().length > 0 &&
            flattenCollectionImageList().map((item: IImageListItem) => {
              return (
                <ImageListItemComponent
                  key={item.id}
                  item={item}
                  itemSize={itemSize}
                  onImageClick={handleImageClick}
                  onUseButtonClick={handleImageUseButtonClick}
                />
              );
            })}
        </div>
        <div ref={outputBottomRef} />

        {(!data || flattenCollectionImageList().length === 0) && (
          <div
            style={{
              height: '100px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Text variant="body1" color={colorSet.gray500}>
              저장한 이미지가 없습니다.
            </Text>
          </div>
        )}
      </Frame>

      <ImageModal
        isVisible={isImageModalVisible}
        onClose={handleImageModalClose}
        initialImageModalType={imageModalType}
        initialSelectedImageInfo={selectedImageInfo}
        initialSequenceInfo={sequenceInfo}
        onUseButtonClick={handleImageUseButtonClick}
      />

      <CollectionUpsertModal
        isVisible={isCollectionUpsertModalVisible}
        onClose={handleCollectionUpsertModalClose}
        targetCollectionId={Number(collectionId)}
        initialCollectionName={initialCollectionName}
      />

      <GuideModal
        isVisible={isCollectionDeleteModalVisible}
        onClick={handleCollectionDeleteConfirmClick}
        onClose={handleCollectionDeleteModalClose}
        title={'컬렉션을 삭제하시겠습니까?'}
        content={'이 작업은 되돌릴 수 없습니다.'}
        buttonText="삭제하기"
        buttonVariant="contained"
        buttonCount={2}
      />
    </>
  );
};

export default CollectionImageListPage;
